module.exports = __webpack_public_path__ + "media/images/icons/twotone/database-949dc48839c321ea954221ad61720d24.svg";